$(document).ready(function() {
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
    if ($('#agree').is(':checked')) {
      $(this).submit();
    }
    else {
      alert(window.translations["terms_and_conditions_error"]);
      return false;
    }
  });

  // Event delegation for tooltip icon (works after DOM updates)
  $(document).on('click', '.variant-description-icon', function() {
    const descriptionBox = $(this).closest('.variant-picker__option-info').find('.variant-description-container');
    descriptionBox.toggleClass('active');
  });
});

document.addEventListener('variant:change', function(event) {
  let variant = event.detail.variant;
  let previousVariant = event.detail.previousVariant;

  $(`[data-variantid="${previousVariant.id}"]`).hide();
  $(`[data-variantid="${variant.id}"]`).show();
});